module.exports = __webpack_public_path__ + "img/sensor-green.d5ee9166.svg";